import React, { FC, useEffect } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
  FormDescription,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'
import { Trans } from 'react-i18next'
import { ExternalLink } from 'src/components/Core/Styles/Link'

export const clientDocumentationLink = <ExternalLink href='https://www.sucdenfinancial.com/en/client-documentation-and-disclosures/' />

const EmirTradeReportingForm: FC<FormProps> = props => {
  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    setFormData,
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    toggleShowByName,
    toggleShowByVisualName,
    configData,
  } = useForm(props.fetchedData, config, submitForm)

  useEffect(() => {
    toggleShowByName(
      'areYouFCOrNFCPlus',
      formData?.isIncorporatedInUK?.value === 'true'
    )

    if(formData.isIncorporatedInUK.value === 'false'){
      setFormData(prev => {
        return {...prev, vatNumber: {
          ...formData.vatNumber,
          value: ''
        }}
      })
    }
  }, [formData?.isIncorporatedInUK?.value])

  useEffect(() => {
    toggleShowByName(
      'doYouDelegateTrade',
      formData?.areYouFCOrNFCPlus?.value === 'true'
    )

    toggleShowByName(
      'otcDerivatives',
      formData?.areYouFCOrNFCPlus?.value === 'false'
    )
    toggleShowByName(
      'exchangeTradedDerivatives',
      formData?.areYouFCOrNFCPlus?.value === 'false'
    )
    toggleShowByVisualName(
      'fCOrNFCNo',
      formData?.areYouFCOrNFCPlus?.value === 'false' ? 'true' : 'false'
    )
  }, [formData?.areYouFCOrNFCPlus?.value])

  useEffect(() => {
    toggleShowByName(
      'otcDerivativesReportOption',
      // @ts-ignore:next-line
      formData?.otcDerivatives?.value === true
    )
  }, [formData?.otcDerivatives?.value])

  useEffect(() => {
    toggleShowByName(
      'exchangeTradeDerivativesReportOption',
      // @ts-ignore:next-line
      formData?.exchangeTradedDerivatives?.value === true
    )
  }, [formData?.exchangeTradedDerivatives?.value])

  useEffect(() => {
    toggleShowByName(
      'vatNumber',
      // @ts-ignore:next-line
      formData?.doYouDelegateTrade?.value === 'true' || formData?.otcDerivativesReportOption?.value === 'true-uk' || formData?.otcDerivativesReportOption?.value === 'true-eea' || formData?.exchangeTradeDerivativesReportOption?.value === 'true'
    )
  }, [formData?.doYouDelegateTrade?.value, formData?.otcDerivativesReportOption?.value, formData?.exchangeTradeDerivativesReportOption?.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t(
            'onboarding.forms.CorporateAccount.EmirTradeReportingForm.title'
          )}
        </FormTitle>
        <FormDescription>
          {/* @ts-ignore-next-line */}
          <Trans
            i18nKey={
              'onboarding.forms.CorporateAccount.EmirTradeReportingForm.visualOnly.infoText.content'
            }
            components={{ mylink: clientDocumentationLink }}
          />
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}

      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation || (formData?.otcDerivatives?.value && formData?.otcDerivativesReportOption?.value === '')}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default EmirTradeReportingForm
